import { render, staticRenderFns } from "./SubmitArtTip.vue?vue&type=template&id=a4c5ef6a&scoped=true"
import script from "./SubmitArtTip.vue?vue&type=script&lang=js"
export * from "./SubmitArtTip.vue?vue&type=script&lang=js"
import style0 from "./SubmitArtTip.vue?vue&type=style&index=0&id=a4c5ef6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c5ef6a",
  null
  
)

export default component.exports